import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { DatePickerInput } from 'react-native-paper-dates';
import { green, placeholder, white } from '@/shared/styles/colors';
import { InputLabel, inputBorderStyle } from './StaticInput';

interface Props {
  labelText: string;
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  containerStyle?: StyleProp<ViewStyle>;
  /** Keep the label visible while empty, like StaticInput's showLabel */
  showLabel?: boolean;
}

/** A date field that looks and lines up like StaticInput */
const DateInput = ({
  labelText,
  value,
  onChange,
  containerStyle,
  showLabel,
}: Props) => (
  <View style={containerStyle}>
    <InputLabel isVisible={showLabel || Boolean(value)}>{labelText}</InputLabel>
    <DatePickerInput
      locale="en"
      label=""
      withDateFormatInLabel={false}
      placeholder="MM/DD/YYYY"
      placeholderTextColor={placeholder}
      value={value}
      onChange={onChange}
      inputMode="start"
      mode="outlined"
      textColor={green}
      iconColor={green}
      outlineStyle={inputBorderStyle}
      style={{ height: 50, paddingLeft: 10, backgroundColor: white }}
    />
  </View>
);

export default DateInput;
